import { useState } from "react";
import { useLanguage } from "./i18n";

/** Three steps, one line each, read top to bottom. */
const STEPS: [string, string][] = [
  ["先找到可尝试部件", "点击下方部件按钮，橙色即该部件。"],
  ["按住左键，缓慢拖动", "转动件拖远离转轴处，滑动件沿滑动方向拖。"],
  ["调整视角与缩放", "空白处拖动转视角；按住 Ctrl（⌘）滚动或双指捏合来缩放。"],
];

export default function InteractionGuide({ practice }: { practice: boolean }) {
  const { t } = useLanguage();
  const [open, setOpen] = useState(practice);
  return <details className="rs-interaction-guide" open={open} onToggle={(event) => setOpen(event.currentTarget.open)}>
    <summary>{t("MuJoCo 操作教学")}<span>{t("随时展开查看")}</span></summary>
    <ol>{STEPS.map(([title, detail], index) =>
      <li key={title}><span>{index + 1}</span><p><strong>{t(title)}</strong>{t(detail)}</p></li>)}</ol>
  </details>;
}
